import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-4b1801b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "dialog-blowdown",
  style: {"width":"1024px","min-height":"510px"}
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "body" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "descriptions-group" }
const _hoisted_7 = { class: "descriptions-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "排污口编码:", -1))
const _hoisted_9 = { class: "value" }
const _hoisted_10 = { class: "descriptions-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "排污口类型:", -1))
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "descriptions-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "一级分类:", -1))
const _hoisted_15 = { class: "value" }
const _hoisted_16 = { class: "descriptions-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "二级分类:", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = { class: "descriptions-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "所在水系:", -1))
const _hoisted_21 = { class: "value" }
const _hoisted_22 = { class: "descriptions-item" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "受纳水体:", -1))
const _hoisted_24 = { class: "value" }
const _hoisted_25 = { class: "descriptions-item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "执行排放标准:", -1))
const _hoisted_27 = { class: "value" }
const _hoisted_28 = { class: "descriptions-item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "废水排放量m3/d:", -1))
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "descriptions-item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "所在镇街:", -1))
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "descriptions-item" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "是否功能分区:", -1))
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "descriptions-item" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "功能区名称:", -1))
const _hoisted_39 = { class: "value" }
const _hoisted_40 = { class: "descriptions-item" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "二级功能区目标:", -1))
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "descriptions-item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "经度:", -1))
const _hoisted_45 = { class: "value" }
const _hoisted_46 = { class: "descriptions-item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "纬度:", -1))
const _hoisted_48 = { class: "value" }
const _hoisted_49 = { class: "descriptions-item" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "是否纳入整治:", -1))
const _hoisted_51 = { class: "value" }
const _hoisted_52 = { class: "descriptions-item" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "是否完成整治:", -1))
const _hoisted_54 = { class: "value" }
const _hoisted_55 = { class: "descriptions-item" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "详细地址:", -1))
const _hoisted_57 = { class: "value" }
const _hoisted_58 = { class: "photo_gallary" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "现场照片:", -1))
const _hoisted_60 = ["src"]
const _hoisted_61 = {
  key: 0,
  style: {"max-height":"600px","overflow-y":"scroll"}
}
const _hoisted_62 = { class: "descriptions-group" }
const _hoisted_63 = { class: "descriptions-item" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "采样位置:", -1))
const _hoisted_65 = { class: "value" }
const _hoisted_66 = { class: "descriptions-item" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "采样位置描述:", -1))
const _hoisted_68 = { class: "value" }
const _hoisted_69 = { class: "descriptions-item" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "采样方法:", -1))
const _hoisted_71 = { class: "value" }
const _hoisted_72 = { class: "descriptions-item" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "监测采样编码:", -1))
const _hoisted_74 = { class: "value" }
const _hoisted_75 = { class: "descriptions-item" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "过水断面面积（m2）:", -1))
const _hoisted_77 = { class: "value" }
const _hoisted_78 = { class: "descriptions-item" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "监测单位名称:", -1))
const _hoisted_80 = { class: "value" }
const _hoisted_81 = { class: "descriptions-item" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "是否已建自动监测站:", -1))
const _hoisted_83 = { class: "value" }
const _hoisted_84 = { class: "descriptions-item" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "是否具备建站条件:", -1))
const _hoisted_86 = { class: "value" }
const _hoisted_87 = { class: "descriptions-item" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key" }, "监测情况", -1))
const _hoisted_89 = { key: 1 }
const _hoisted_90 = {
  class: "auto_top_bar",
  style: {"margin-bottom":"10px"}
}
const _hoisted_91 = { class: "left_bar" }
const _hoisted_92 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_93 = { class: "tabs" }
const _hoisted_94 = { class: "frequency-box" }
const _hoisted_95 = { class: "frequency-box" }
const _hoisted_96 = { class: "options" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = {
  class: "auto_top_bar",
  style: {"margin-bottom":"10px"}
}
const _hoisted_99 = { class: "left_bar" }
const _hoisted_100 = { class: "right_bar" }
const _hoisted_101 = { class: "options" }
const _hoisted_102 = ["onClick"]
const _hoisted_103 = {
  class: "auto_top_bar",
  style: {"margin-bottom":"10px"}
}
const _hoisted_104 = { class: "left_bar" }
const _hoisted_105 = { class: "right_bar" }
const _hoisted_106 = { class: "bottom_tool" }
const _hoisted_107 = { class: "wtqd" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "巡查记录", -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "巡查结论：", -1))
const _hoisted_110 = { key: 0 }
const _hoisted_111 = ["src"]
const _hoisted_112 = { key: 1 }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "暂无图片")
], -1))
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = { class: "wtqd" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "问题清单", -1))
const _hoisted_117 = { style: {"display":"flex"} }
const _hoisted_118 = {
  ref: "videoContainer",
  class: "video-box"
}
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("video", {
  id: "pop_video",
  style: {"width":"100%","height":"100%"}
}, null, -1))
const _hoisted_120 = [
  _hoisted_119
]
const _hoisted_121 = {
  class: "right wtqd",
  style: {"padding-left":"10px"}
}
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title",
  style: {"line-height":"28px","margin-bottom":"10px"}
}, "问题清单", -1))

import { toRefs, ref, onMounted, onBeforeUnmount, h, nextTick } from 'vue'
import {
  VideoMonitorPointDto,
  CodeReqDto,
  EventListDto,
  PwkBasicRespDto,
  PwkZdjcReqDto,
  Api as SjApi,
  XcjlPageDto,
} from '@/api/screenSj'
import Video from 'video.js'
import { Api as GridApi } from '@/api/grid'
import moment from 'moment'
import ListTable from '@/components/common/ListTable.vue'
import Bus from '@/config/Bus'
import mapService, { BreatheLayer } from '@/utils/mapServices'


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogRhpk',
  props: {
  data: Object,
},
  setup(__props) {

const props = __props
const { data } = toRefs(props)
const sjApi = new SjApi()
const gridApi = new GridApi()

const activeVideo = ref(null)
const activeSzDevice = ref(null)
const activeLlDevice = ref(null)
const videoList: any = ref([])
const szDeviceList: any = ref([])
const llDeviceList: any = ref([])

const currentCode = ref('')
const currentCode2 = ref('')
const unit = ref('')
const factorName = ref('')
const factorName2 = ref('')
const tabs = ref(['水质', '流量'])
const tabAc = ref('水质')
const factorOptions = ref([])
const factorOptions2 = ref([])
const time = ref(new Date().getTime())
const time2 = ref(new Date().getTime())
const tableDataSz = ref([])
const tableDataLl = ref([])
const columnSz = ref([])
const columnLl = ref([])
const frequencySz = ref('R')
const frequencyLl = ref('R')

const columns = ref([
  {
    title: '序号',
    key: 'no',
    width: 60,
    align: 'center',
    render(row, index) {
      return h(
        `span`,
        {},
        {
          default: () => index + 1,
        }
      )
    },
  },
  {
    title: '时间',
    key: 'reportTimeStr',
    width: 120,
    align: 'center',
  },
  {
    title: '名称',
    key: 'problemName',
    align: 'center',
  },
  {
    title: '状态',
    key: 'problemStatus',
    width: 80,
    align: 'center',
    render(row, index) {
      let className = 'tag dcl'
      if (row.problemStatus === 1) {
        className = 'tag dcl'
      }
      if (row.problemStatus === 2) {
        className = 'tag clz'
      }
      if (row.problemStatus === 3) {
        className = 'tag ywj'
      }
      return h(
        `div`,
        {
          class: className,
        },
        {
          default: () => row.problemStatusStr,
        }
      )
    },
  },
])
const videoProblemList = ref([])

let player: {
  dispose: () => void
  on: (arg0: string, arg1: () => void) => void
  play: () => void
  ready: (arg0: () => void) => void
  currentTime: (arg0: number) => void
}

//--------------------------------------周边信息-----------------------------------------
const basicData = ref<PwkBasicRespDto | undefined>({})

// 查看排污口周边
function showAround() {
  const params: CodeReqDto = {
    code: data?.value?.id || '',
  }
  sjApi.screen.ckzbUsingPost1(params).then((res) => {
    if (res.data) {
      console.log(res.data, 'res.data')
      const pdata = res.data.self || {}
      const pointData = {
        type: 'FeatureCollection',
        features: [],
      }
      if (pdata.jd && pdata.wd) {
        mapService.removeLayer('pwk')
        const data = {
          id: 0,
          geometry: {
            type: 'Point',
            coordinates: [parseFloat(pdata.jd), parseFloat(pdata.wd)],
          },
          properties: {
            ...pdata,
            name: pdata.name,
            modalType: 'pwk',
            category: 'pwk',
            icon: `重点排水户_0.png`,
            jd: pdata.jd,
            wd: pdata.wd,
          },
          type: 'Feature',
        }
        pointData.features.push(data)
        const breathe = new BreatheLayer('pwk', pointData, ``, 0.7, false)
        breathe.showAnimate(1000, 'Elastic.Out')
        mapService.showLayer(breathe)
        Bus.emit('closeModal')
      }
    }
  })
}

/**
 * @description: 获取基本信息
 * @return {*}
 */
function fetchBasicData() {
  if (data?.value?.id) {
    const parasm: CodeReqDto = {
      code: data.value.id,
    }
    sjApi.screen
      .pwkBasicUsingPost1(parasm)
      .then((res) => {
        if (res.data) {
          basicData.value = res.data
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

/**
 * @description: 获取排查信息
 * @return {*}
 */
function fetchPcxxData() { }

//--------------------------------------监测信息-----------------------------------------
const isSg = ref<boolean>(true)
const jcxxSgData = ref<any[] | undefined>([])
/**
 * @description: 切换监测类型
 * @param {*} bol
 * @return {*}
 */
function onChangeJcType(bol: boolean) {
  isSg.value = bol
  if (bol) {
    fetchJcxxData()
  } else {
    fetchJcxxZdData()
  }
}
/**
 * @description: 获取监测信息
 * @return {*}
 */
function fetchJcxxData() {
  if (data?.value?.id) {
    const params: CodeReqDto = {
      code: data?.value.id,
    }
    sjApi.screen
      .pwksgjcUsingPost1(params)
      .then((res) => {
        if (res.data) {
          jcxxSgData.value = res.data.map((item) => {
            const column: any[] = []
            item.sgjcMonitors?.map((factor) => {
              column.push({
                key: factor.factorCode,
                label: factor.factorName,
                iscb: factor.factorCode + '_cb',
              })
            })
            const tableData: any[] = []
            let monitorRes: any = {}
            item.sgjcMonitors?.map((factor) => {
              if (factor.factorName) {
                monitorRes[factor.factorCode] = factor.monitorValue || '--'
                if(factor.monitorValue && factor.standValue && (factor.monitorValue > factor.standValue)) {
                  monitorRes[factor.factorCode + '_cb'] = true
                }
              }
            })
            
            tableData.push(monitorRes)
            return {
              ...item,
              column,
              tableData,
            }
          })
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }
}
const jcxxZdData = ref<any>({})
const dateTime = ref(new Date().getTime())
/**
 * @description: 获取自动监测信息
 * @return {*}
 */
function fetchJcxxZdData() {
  // if (data?.value?.id) {
  //   const params: PwkZdjcReqDto = {
  //     code: data?.value.id,
  //     dateTime: moment(dateTime.value).format('yyyy-MM-DD'),
  //   }
  //   sjApi.screen
  //     .pwkzdjcUsingPost1(params)
  //     .then((res) => {
  //       if (res.data) {
  //         let column: any[] = []
  //         if (res.data?.headers) {
  //           column = res.data?.headers?.map((obj) => {
  //             return {
  //               key: obj.identifier,
  //               label: obj.name + (obj.unit ? '(' + obj.unit + ')' : ''),
  //             }
  //           })
  //         }
  //         jcxxZdData.value.column = column || []
  //         jcxxZdData.value.tableData = res.data.rows || []
  //         jcxxZdData.value.zxpfbz = res.data.zxpfbz || ''
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err)
  //     })
  // }
  if (data?.value?.id) {
    const params: CodeReqDto = {
      code: data.value.id,
    }
    sjApi.screen.monitorDeviceGroupUsingGET(params).then((res) => {
      if (res.code === 200) {
        let data1 = res.data?.szjcDevices || []
        let data2 = res.data?.llDevices || []
        szDeviceList.value = []
        llDeviceList.value = []
        for (let i = 0; i < data1.length; i++) {
          szDeviceList.value.push(
            {
              label: data1[i].deviceName,
              value: data1[i].deviceCode
            },
          )
        }
        for (let i = 0; i < data2.length; i++) {
          llDeviceList.value.push(
            {
              label: data2[i].deviceName,
              value: data2[i].deviceCode
            },
          )
        }
        activeSzDevice.value = szDeviceList.value[0] ? szDeviceList.value[0].value : ''
        activeLlDevice.value = llDeviceList.value[0] ? llDeviceList.value[0].value : ''
        if (szDeviceList.value.length > 0) {
          changeSzDevice(szDeviceList.value[0].value)
        }
        if (llDeviceList.value.length > 0) {
          changeLlDevice(llDeviceList.value[0].value)
        }
      }
    })
  }
}

function getMonitorDataListPostSz() {
  if(!activeSzDevice.value) {
    return
  }
  let date = new Date(time.value)
  let startTime = new Date(date.setHours(0, 0, 0, 0))
  let endTime
  if (frequencySz.value === 'R' || frequencySz.value === 'H') {
    endTime = new Date(date.setHours(23, 59, 59, 999))
  }
  else {
    startTime = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0)
    endTime = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999)
  }
  const params = {
    frequency: frequencySz.value,
    deviceCode: activeSzDevice.value,
    startTime: moment(startTime).format("YYYY-MM-DD HH:mm:ss"),
    endTime: moment(endTime).format("YYYY-MM-DD HH:mm:ss"),
    size: 999
  }
  sjApi.screen.getMonitorDataListPost(params).then((res) => {
    if (res.code === 200) {
      const titleModels: any[] = res.data?.titleModels || []
      // 监测时间列放到最前面
      titleModels.sort((a, b) => (a.factorCode === 'data_time' ? -1 : b.factorCode === 'data_time' ? 1 : 0))
      columnSz.value = titleModels.map((item) => {
        return {
          key: item.factorCode,
          label: item.factorName + (item.unit ? '(' + item.unit + ')' : ''),
          width: item.factorCode === 'data_time' ? '160px' : 'auto',
          // 超标标记，ListTable 中该字段为 true 时数值标红
          iscb: item.factorCode + '_cb',
        }
      })
      tableDataSz.value = (res.data?.monitorDataRespDtos || []).map((dto) => {
        const row: any = { key: dto.data_time?.value }
        titleModels.forEach((item) => {
          const factor = dto[item.factorCode]
          row[item.factorCode] =
            factor && factor.valid !== false && factor.value !== null && factor.value !== undefined
              ? String(factor.value)
              : '--'
          row[item.factorCode + '_cb'] = !!factor?.cb
        })
        return row
      })
    }
  })
}
function getMonitorDataListPostLl() {
  if(!activeLlDevice.value) {
    return
  }
  let date = new Date(time2.value)
  let startTime = new Date(date.setHours(0, 0, 0, 0))
  let endTime
  if (frequencyLl.value === 'R' || frequencyLl.value === 'H') {
    endTime = new Date(date.setHours(23, 59, 59, 999))
  }
  else {
    startTime = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0)
    endTime = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999)
  }
  const params = {
    frequency: frequencyLl.value,
    deviceCode: activeLlDevice.value,
    startTime: moment(startTime).format("YYYY-MM-DD HH:mm:ss"),
    endTime: moment(endTime).format("YYYY-MM-DD HH:mm:ss"),
    size: 999
  }
  sjApi.screen.getMonitorDataListPost(params).then((res) => {
    if (res.code === 200) {
      const titleModels: any[] = res.data?.titleModels || []
      // 监测时间列放到最前面
      titleModels.sort((a, b) => (a.factorCode === 'data_time' ? -1 : b.factorCode === 'data_time' ? 1 : 0))
      columnLl.value = titleModels.map((item) => {
        return {
          key: item.factorCode,
          label: item.factorName + (item.unit ? '(' + item.unit + ')' : ''),
          width: item.factorCode === 'data_time' ? '160px' : 'auto',
          // 超标标记，ListTable 中该字段为 true 时数值标红
          iscb: item.factorCode + '_cb',
        }
      })
      tableDataLl.value = (res.data?.monitorDataRespDtos || []).map((dto) => {
        const row: any = { key: dto.data_time?.value }
        titleModels.forEach((item) => {
          const factor = dto[item.factorCode]
          row[item.factorCode] =
            factor && factor.valid !== false && factor.value !== null && factor.value !== undefined
              ? String(factor.value)
              : '--'
          row[item.factorCode + '_cb'] = !!factor?.cb
        })
        return row
      })
    }
  })
}

function changeSzDevice(deviceCodes) {
  activeSzDevice.value = deviceCodes
  getMonitorDataListPostSz()
}

function changeLlDevice(deviceCodes) {
  activeLlDevice.value = deviceCodes
  getMonitorDataListPostLl()
}

/**
 * @description: 获取溯源信息
 * @return {*}
 */
function fetchSyxxData() { }

/**
 * @description: 获取整治信息
 * @return {*}
 */
function fetchZzxxData() { }

/**
 * @description: 获取监管信息
 * @return {*}
 */
function fetchJgxxData() { }

/**
 * @description: 获取河长信息
 * @return {*}
 */
function fetchHzxxData() { }

//--------------------------------------巡查信息-----------------------------------------
const xcjlList = ref<XcjlPageDto[] | undefined>([])
const xcjlColumns: any[] = [
  {
    key: 'wgbh',
    title: '网格编号',
  },
  {
    key: 'hdqd',
    title: '河段起点',
  },
  {
    key: 'hdzd',
    title: '河段终点',
  },
  {
    key: 'xhr',
    title: '巡查人',
  },
  {
    key: 'sbwts',
    title: '上报问题数',
  },
  {
    key: 'xhzt',
    title: '巡河状态',
  },
  {
    key: 'xhkssj',
    title: '巡查开始时间',
  },
  {
    key: 'xhjssj',
    title: '巡查结束时间',
  },
  {
    title: '巡查结果',
    render(row: any) {
      return h(
        'a',
        {
          style: {
            color: '#fff',
          },
          onClick: () => {
            gotoXcDetail(row.id)
          },
        },
        '查看结果'
      )
    },
  },
]
const xcxqModal = ref(false)
const xcDetail = ref<any>({})
/**
 * @description: 巡查详情
 * @param {*} id
 * @return {*}
 */
function gotoXcDetail(id: number) {
  const params = {
    id: id,
  }
  gridApi.openapi
    .xcjlDetailUsingPost(params)
    .then((res) => {
      if (res.data) {
        xcDetail.value.xcjl = res.data.xhResult || '已巡查完成'
        xcDetail.value.xcjlImg = res.data.files
          ?.filter((file) => {
            return file.fileType == 'image'
          })
          .map((item) => {
            return item.url || ''
          })
        xcjlLoading.value = false
        console.log(xcDetail.value)
      }
    })
    .catch((err) => {
      console.log(err)
    })
}
const wtqdLoading = ref(false)
const xcjlLoading = ref(false)
const xcwtList = ref<EventListDto[] | undefined>([])
const xcwtColumns: any[] = [
  {
    key: 'id',
    title: '编号',
  },
  {
    key: 'problemName',
    title: '问题名称',
  },
  {
    key: 'createUser',
    title: '上报人',
  },
  {
    key: 'reportTimeStr',
    title: '上报时间',
  },
  {
    key: 'problemStatusStr',
    title: '处理状态',
  },
  {
    key: 'currentHandleUser',
    title: '当前处理人',
  },
  {
    title: '详情',
    render(row: any) {
      return h(
        'a',
        {
          style: {
            color: '#fff',
          },
          onClick: () => {
            gotoWtDetail(row.id)
          },
        },
        '查看详情'
      )
    },
  },
]
function gotoWtDetail(id: string) {
  Bus.emit('showModal', {
    modalType: '问题详情',
    data: { id: id },
  })
}
/**
 * @description: 获取巡查信息
 * @return {*}
 */
function fetchXcxxData() {
  const params = {
    code: data?.value?.id,
    page: 1,
    pageSize: 100,
  }
  xcjlLoading.value = true
  wtqdLoading.value = true
  sjApi.screen
    .pwkwtqdPageUsingPost1(params)
    .then((res) => {
      if (res.data) {
        xcwtList.value = res.data.items
      }
      wtqdLoading.value = false
    })
    .catch((err) => {
      wtqdLoading.value = false
      console.log(err)
    })
  sjApi.screen
    .pwkxcjlPageUsingPost1(params)
    .then((res) => {
      if (res.data) {
        xcjlList.value = res.data.items
      }
      xcjlLoading.value = false
    })
    .catch((err) => {
      xcjlLoading.value = false
      console.log(err)
    })
}

/**
 * @description: 获取视频监控
 * @return {*}
 */
function fetchSpjkData() {
  if (data?.value?.id) {
    const params: CodeReqDto = {
      code: data.value.id,
    }
    sjApi.screen.monitorDeviceGroupUsingGET(params).then((res) => {
      if (res.code === 200) {
        let data = res.data?.videoDevices || []
        videoList.value = []
        let deviceCodes = []
        for (let i = 0; i < data.length; i++) {
          videoList.value.push(
            {
              label: data[i].deviceName,
              value: data[i].deviceCode
            },
          )
          deviceCodes.push(data[i].deviceCode)
        }

        const params2 = {
          deviceCodes: deviceCodes,
          size: 999
        }
        // sjApi.screen.getVideoProblemListPost(params2).then((res) => {
        //   if (res.code === 200) {
        //     videoProblemList.value = res.data.items
        //   }
        // })

        nextTick(() => {
          const option = {
            muted: false,
            controls: true,
            loop: false,
            autoplay: false,
            sources: [],
            notSupportedMessage: '此视频暂无法播放，请稍后再试',
            // poster:,
            // src: 'blob:https://www.bilibili.com/81b9cf25-01f8-4ac5-b8be-7f9b4f07fa8b',
          }
          // 初始化的时候标签默认都是显示的
          player = Video('pop_video', option, () => {
            player.on('error', () => {
              player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
              console.log('视频加载错误')
            })
          })
          activeVideo.value = videoList.value[0].value
          changeVideo(videoList.value[0].value)
        });
      }
    })
  }
}

/**
 * @description: 模块切换回调
 * @param {*} value
 * @return {*}
 */
function onTabChange(value: string | number) {
  console.log('onTabChange', value)
  switch (value) {
    case 'jbxx':
      fetchBasicData()
      break
    case 'pcxx':
      fetchPcxxData()
      break
    case 'jcxx':
      fetchJcxxData()
      break
    case 'syxx':
      fetchSyxxData()
      break
    case 'zzxx':
      fetchZzxxData()
      break
    case 'jgxx':
      fetchJgxxData()
      break
    case 'hzxx':
      fetchHzxxData()
      break
    case 'xcxx':
      fetchXcxxData()
      break
    case 'spjk':
      fetchSpjkData()
      break
    default:
      break
  }
}

const changeVideo = (deviceId) => {
  const params: VideoMonitorPointDto = {
    videoDeviceCode: deviceId,
  }
  sjApi.screen.getVideoStreamGET(params).then((res) => {
    if (res.code === 200) {
      let url = ''
      for (let i = 0; i < res.data.length; i++) {
        if (res.data[i].videoDeviceCode === deviceId) {
          url = res.data[i].videoStream
          break
        }
      }
      player.src({
        type: '',
        src: url,
      })
      player.play()
    }
  })
}

// 问题详情
const problemDetails = (row: any) => {
  return {
    style: 'cursor: pointer;',
    onClick: () => {
      // Bus.emit('2showModal', {
      //   data: row,
      //   modalType: '问题详情',
      // })
    },
  }
}

const setTab = (val: string) => {
  tabAc.value = val;
  // val === '水质' ? initData() : initData2();
}

const handleData = (val) => {
  currentCode.value = val.factorCode;
  unit.value = val.unit;
  factorName.value = val.factorName;
}
const handleData2 = (val) => {
  currentCode2.value = val.factorCode;
  factorName2.value = val.factorName;
}

const onTimeChange = (val) => {
  time.value = val;
  getMonitorDataListPostSz()
}
const onTimeChange2 = (val) => {
  time2.value = val;
  getMonitorDataListPostLl()
}

const changeFrequencySz = (val: string) => {
  frequencySz.value = val
  getMonitorDataListPostSz()
}
const changeFrequencyLl = (val: string) => {
  frequencyLl.value = val
  getMonitorDataListPostLl()
}

onMounted(() => {
  fetchBasicData()
})

onBeforeUnmount(() => {
  setTimeout(() => {
    player.dispose()
  }, 200)
})

return (_ctx: any,_cache: any) => {
  const _component_n_tab_pane = _resolveComponent("n-tab-pane")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_data_table = _resolveComponent("n-data-table")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_modal = _resolveComponent("n-modal")!
  const _component_n_tabs = _resolveComponent("n-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(data)?.name || '-'), 1),
      _createElementVNode("div", {
        class: "title",
        onClick: showAround
      }, "查看周边")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_n_tabs, {
          type: "line",
          "on-update:value": onTabChange,
          animated: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_n_tab_pane, {
              name: "jbxx",
              tab: "基本信息"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("span", _hoisted_9, _toDisplayString(basicData.value?.pwkbm || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("span", _hoisted_12, _toDisplayString(basicData.value?.pwklx || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, _toDisplayString(basicData.value?.yjfl || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", _hoisted_18, _toDisplayString(basicData.value?.ejfl || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("span", _hoisted_21, _toDisplayString(basicData.value?.pwkszsx || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _createElementVNode("span", _hoisted_24, _toDisplayString(basicData.value?.snst || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("span", _hoisted_27, _toDisplayString(basicData.value?.zxpfbz || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("span", _hoisted_30, _toDisplayString(basicData.value?.fspflD || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("span", _hoisted_33, _toDisplayString(basicData.value?.szzj || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("span", _hoisted_36, _toDisplayString(basicData.value?.sfysgnq || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("span", _hoisted_39, _toDisplayString(basicData.value?.ejgnq || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("span", _hoisted_42, _toDisplayString(basicData.value?.ejgnqmb || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _createElementVNode("span", _hoisted_45, _toDisplayString(basicData.value?.jd || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("span", _hoisted_48, _toDisplayString(basicData.value?.wd || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_49, [
                    _hoisted_50,
                    _createElementVNode("span", _hoisted_51, _toDisplayString(basicData.value?.sfnrzz || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("span", _hoisted_54, _toDisplayString(basicData.value?.sfwczz || '-'), 1)
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _hoisted_56,
                    _createElementVNode("span", _hoisted_57, _toDisplayString(basicData.value?.pwkxxdz || '-'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(basicData.value?.xczp, (item) => {
                    return (_openBlock(), _createElementBlock("img", {
                      style: {"max-width":"320px"},
                      src: item,
                      alt: ""
                    }, null, 8, _hoisted_60))
                  }), 256))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_n_tab_pane, {
              name: "pcxx",
              tab: "排查信息"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 排查信息 ")
              ]),
              _: 1
            }),
            _createVNode(_component_n_tab_pane, {
              name: "jcxx",
              tab: "监测信息"
            }, {
              default: _withCtx(() => [
                (isSg.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jcxxSgData.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("div", { key: index }, [
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("p", null, "排查时间：" + _toDisplayString(item.xccysj || '-'), 1),
                            _createElementVNode("div", _hoisted_63, [
                              _hoisted_64,
                              _createElementVNode("span", _hoisted_65, _toDisplayString(item?.cywz || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_66, [
                              _hoisted_67,
                              _createElementVNode("span", _hoisted_68, _toDisplayString(item?.cyxcqkms || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_69, [
                              _hoisted_70,
                              _createElementVNode("span", _hoisted_71, _toDisplayString(item?.cyfs || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_72, [
                              _hoisted_73,
                              _createElementVNode("span", _hoisted_74, _toDisplayString(item?.jccybm || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_75, [
                              _hoisted_76,
                              _createElementVNode("span", _hoisted_77, _toDisplayString(item?.gsdmmj || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_78, [
                              _hoisted_79,
                              _createElementVNode("span", _hoisted_80, _toDisplayString(item?.jcdw || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_81, [
                              _hoisted_82,
                              _createElementVNode("span", _hoisted_83, _toDisplayString(item?.sfyjczdjcz || '-'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_84, [
                              _hoisted_85,
                              _createElementVNode("span", _hoisted_86, _toDisplayString(item?.sfjbjzdjcztj || '-'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_87, [
                            _hoisted_88,
                            _createVNode(ListTable, {
                              tableData: item.tableData,
                              tableColumns: item.column,
                              horizontal: true,
                              maxHeight: "200px"
                            }, null, 8, ["tableData", "tableColumns"])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (!isSg.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                      _createElementVNode("div", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, "执行标准" + _toDisplayString(jcxxZdData.value.zxpfbz), 1)
                      ]),
                      _createElementVNode("div", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["s-title s-title2", { 's-title-ac': tabAc.value === '水质' }]),
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (setTab('水质')))
                          }, "水质监测数据 ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["s-title s-title2 ml10", { 's-title-ac': tabAc.value === '流量' }]),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (setTab('流量')))
                          }, " 流量监测数据 ", 2)
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["frequency-btn", { active: frequencySz.value === 'R' }]),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (changeFrequencySz('R')))
                          }, " 实时 ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["frequency-btn", { active: frequencySz.value === 'H' }]),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (changeFrequencySz('H')))
                          }, " 小时 ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["frequency-btn", { active: frequencySz.value === 'D' }]),
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (changeFrequencySz('D')))
                          }, " 天 ", 2)
                        ], 512), [
                          [_vShow, tabAc.value === '水质']
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_95, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["frequency-btn", { active: frequencyLl.value === 'R' }]),
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (changeFrequencyLl('R')))
                          }, " 实时 ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["frequency-btn", { active: frequencyLl.value === 'H' }]),
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (changeFrequencyLl('H')))
                          }, " 小时 ", 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["frequency-btn", { active: frequencyLl.value === 'D' }]),
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (changeFrequencyLl('D')))
                          }, " 天 ", 2)
                        ], 512), [
                          [_vShow, tabAc.value === '流量']
                        ])
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_96, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factorOptions.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: _normalizeClass(["factor", { active: currentCode.value === item.factorCode }]),
                              onClick: ($event: any) => (handleData(item))
                            }, _toDisplayString(item.factorName), 11, _hoisted_97))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _createVNode(_component_n_select, {
                              style: {"width":"400px"},
                              value: activeSzDevice.value,
                              "onUpdate:value": [
                                _cache[8] || (_cache[8] = ($event: any) => ((activeSzDevice).value = $event)),
                                changeSzDevice
                              ],
                              size: "small",
                              options: szDeviceList.value
                            }, null, 8, ["value", "options"])
                          ]),
                          _createElementVNode("div", _hoisted_100, [
                            _withDirectives(_createVNode(_component_n_date_picker, {
                              value: time.value,
                              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((time).value = $event)),
                              size: "small",
                              type: "month",
                              "on-update:value": onTimeChange,
                              format: "yyyy-MM"
                            }, null, 8, ["value"]), [
                              [_vShow, frequencySz.value === 'D']
                            ]),
                            _withDirectives(_createVNode(_component_n_date_picker, {
                              value: time.value,
                              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((time).value = $event)),
                              size: "small",
                              type: "date",
                              "on-update:value": onTimeChange,
                              format: "yyyy-MM-dd"
                            }, null, 8, ["value"]), [
                              [_vShow, frequencySz.value === 'R' || frequencySz.value === 'H']
                            ])
                          ])
                        ]),
                        _createVNode(ListTable, {
                          tableData: tableDataSz.value,
                          tableColumns: columnSz.value,
                          maxHeight: "200px",
                          style: {"margin-bottom":"10px"}
                        }, null, 8, ["tableData", "tableColumns"])
                      ], 512), [
                        [_vShow, tabAc.value === '水质']
                      ]),
                      _withDirectives(_createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_101, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factorOptions2.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: _normalizeClass(["factor", { active: currentCode2.value === item.factorCode }]),
                              onClick: ($event: any) => (handleData2(item))
                            }, _toDisplayString(item.factorName), 11, _hoisted_102))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_103, [
                          _createElementVNode("div", _hoisted_104, [
                            _createVNode(_component_n_select, {
                              style: {"width":"400px"},
                              value: activeLlDevice.value,
                              "onUpdate:value": [
                                _cache[11] || (_cache[11] = ($event: any) => ((activeLlDevice).value = $event)),
                                changeLlDevice
                              ],
                              size: "small",
                              options: llDeviceList.value
                            }, null, 8, ["value", "options"])
                          ]),
                          _createElementVNode("div", _hoisted_105, [
                            _withDirectives(_createVNode(_component_n_date_picker, {
                              value: time2.value,
                              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((time2).value = $event)),
                              size: "small",
                              type: "month",
                              "on-update:value": onTimeChange2,
                              format: "yyyy-MM"
                            }, null, 8, ["value"]), [
                              [_vShow, frequencyLl.value === 'D']
                            ]),
                            _withDirectives(_createVNode(_component_n_date_picker, {
                              value: time2.value,
                              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((time2).value = $event)),
                              size: "small",
                              type: "date",
                              "on-update:value": onTimeChange2,
                              format: "yyyy-MM-dd"
                            }, null, 8, ["value"]), [
                              [_vShow, frequencyLl.value === 'R' || frequencyLl.value === 'H']
                            ])
                          ])
                        ]),
                        _createVNode(ListTable, {
                          tableData: tableDataLl.value,
                          tableColumns: columnLl.value,
                          maxHeight: "200px",
                          style: {"margin-bottom":"10px"}
                        }, null, 8, ["tableData", "tableColumns"])
                      ], 512), [
                        [_vShow, tabAc.value === '流量']
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_106, [
                  _createVNode(_component_n_button, {
                    type: isSg.value ? 'primary' : 'default',
                    size: "small",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (onChangeJcType(true)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("手工监测")
                    ]),
                    _: 1
                  }, 8, ["type"]),
                  _createVNode(_component_n_button, {
                    type: isSg.value ? 'default' : 'primary',
                    size: "small",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (onChangeJcType(false)))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("自动监测")
                    ]),
                    _: 1
                  }, 8, ["type"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_n_tab_pane, {
              name: "syxx",
              tab: "溯源信息"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 溯源信息 ")
              ]),
              _: 1
            }),
            _createVNode(_component_n_tab_pane, {
              name: "zzxx",
              tab: "整治信息"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 整治信息 ")
              ]),
              _: 1
            }),
            _createVNode(_component_n_tab_pane, {
              name: "jgxx",
              tab: "监管信息"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 监管信息 ")
              ]),
              _: 1
            }),
            _createVNode(_component_n_tab_pane, {
              name: "hzxx",
              tab: "河长信息"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 河长信息 ")
              ]),
              _: 1
            }),
            _createVNode(_component_n_tab_pane, {
              name: "xcxx",
              tab: "巡查信息"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_107, [
                  _hoisted_108,
                  _createVNode(_component_n_data_table, {
                    data: xcjlList.value,
                    columns: xcjlColumns,
                    bordered: false,
                    loading: xcjlLoading.value,
                    "max-height": "240px"
                  }, null, 8, ["data", "loading"]),
                  _createVNode(_component_n_modal, {
                    class: "my_deep_dialog",
                    show: xcxqModal.value,
                    "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => ((xcxqModal).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_n_card, {
                        style: {"width":"auto"},
                        bordered: false,
                        size: "huge",
                        role: "dialog",
                        "aria-modal": "true"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _hoisted_109,
                            _createElementVNode("span", null, _toDisplayString(xcDetail.value.xcjl || ''), 1)
                          ]),
                          (xcDetail.value.xcjlImg && xcDetail.value.xcjlImg.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(xcDetail.value.xcjlImg, (img) => {
                                  return (_openBlock(), _createElementBlock("img", {
                                    style: {"max-width":"200px","height":"100px"},
                                    src: img,
                                    alt: ""
                                  }, null, 8, _hoisted_111))
                                }), 256))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_112, _hoisted_114))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["show"])
                ]),
                _createElementVNode("div", _hoisted_115, [
                  _hoisted_116,
                  _createVNode(_component_n_data_table, {
                    data: xcwtList.value,
                    columns: xcwtColumns,
                    loading: wtqdLoading.value,
                    "max-height": "240px",
                    bordered: false
                  }, null, 8, ["data", "loading"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_n_tab_pane, {
              name: "spjk",
              tab: "视频监控"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_117, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_n_select, {
                      style: {"min-width":"200px","max-width":"320px","margin-bottom":"10px"},
                      value: activeVideo.value,
                      "onUpdate:value": [
                        _cache[17] || (_cache[17] = ($event: any) => ((activeVideo).value = $event)),
                        changeVideo
                      ],
                      size: "small",
                      options: videoList.value
                    }, null, 8, ["value", "options"]),
                    _createElementVNode("div", _hoisted_118, _hoisted_120, 512)
                  ]),
                  _createElementVNode("div", _hoisted_121, [
                    _hoisted_122,
                    _createVNode(_component_n_data_table, {
                      "max-height": "530",
                      columns: columns.value,
                      data: videoProblemList.value,
                      pagination: false,
                      "row-props": problemDetails,
                      bordered: false
                    }, null, 8, ["columns", "data"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})